import { Flex } from "@mantine/core"
import { useElementSize } from "@mantine/hooks"
import { CalendarAppointment } from "../../../../../../../@client/Theasoft_ApiServer_Calendar"
import { CalendarAppointmentIndicator } from "./CalendarAppointmentIndicator"
import { SegmentCalendarAppointmentsToHalfDays } from "../../../SegmentCalendarAppointmentsToHalfDays"

interface Props {
  appointments: CalendarAppointment[]
}

export function CalendarAppointmentsSegmentedIndicator({
  appointments,
}: Props) {
  const { ref, width, height } = useElementSize()

  const { firstHalfOfDay, secondHalfOfDay } =
    SegmentCalendarAppointmentsToHalfDays(appointments)

  return (
    <Flex justify="space-evenly" ref={ref} w="100%">
      <CalendarAppointmentIndicator
        appointments={firstHalfOfDay}
        parentHeight={height}
        parentWidth={width}
      />
      <CalendarAppointmentIndicator
        appointments={secondHalfOfDay}
        parentHeight={height}
        parentWidth={width}
      />
    </Flex>
  )
}
